import {
    InlineOptions
} from '../../imports/fancybox-options'

export default class accountCtrl {
    constructor($scope, $http, $rootScope, $compile, bsLoadingOverlayService, $timeout) {
        'ngInject';
        $scope.loggeduser = {};
        $scope.enabledForm = {};
        $scope.enabledForm.details = 0;

        /**
         * FORMS INIT
         */
        $scope.loginForm = {};
        $scope.resetPassForm = {};
        $scope.registerForm = {};
        $scope.updateUserForm = {};
        $scope.updateUserAddressForm = {};

        $scope.opening = false;

        // Forms States, Messages and responses
        var formSettingsTpl = {
            opening: false,
            loading: false,
            status: false,
            message: ''
        };

        $scope.frms_loginForm = formSettingsTpl
        $scope.frms_resetPassForm = formSettingsTpl;
        $scope.frms_registerForm = formSettingsTpl;

        $scope.validationOptions = {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messages: {
                bill_code: {
                    required: "required"
                },
                ship_code: {
                    required: "required"
                },
            },
            ignore: [],
            errorPlacement: function (error, element) {
                if ($(element).is(":radio")) {
                    var hidELement = $(element).parent().parent().parent();
                    error.appendTo(hidELement);

                } else if ($(element).is("select")) {

                    var hidELement = $(element).parent().find('span.select2.select2-container');
                    error.insertAfter(hidELement);

                } else if ($(element).is(":hidden")) {
                    var hidELement = $(element).parent();
                    error.insertAfter(hidELement);
                } else {
                    error.insertAfter(element);
                }
            },
            highlight: function (element, errorClass, validClass) {
                if ($(element).is(":hidden")) {
                    $(element)
                        .parent()
                        .addClass(errorClass)
                        .removeClass(validClass);
                } else {
                    $(element)
                        .addClass(errorClass)
                        .removeClass(validClass);

                    $(element)
                        .prev()
                        .addClass('top-error');

                    $(element)
                        .parent()
                        .addClass('error')
                }
            },
            unhighlight: function (element, errorClass, validClass) {

                if ($(element).is(":hidden")) {
                    $(element)
                        .parent()
                        .removeClass(errorClass)
                        .addClass(validClass);
                } else {
                    $(element)
                        .removeClass(errorClass)
                        .addClass(validClass);

                    $(element)
                        .prev()
                        .removeClass('top-error');

                    $(element)
                        .parent()
                        .removeClass('error')
                }
            }
        };

        $scope.fancyboxOptions = InlineOptions;

        $scope.reg_countries = $scope.reg_regions = {};

        // Dummy registration data
        $scope.regform = {
            'user_fname': '',
            'user_lname': '',
            'email': '',
            'country': '',
            'phone': '',
            'address': '',
            'apt': '',
            'city': '',
            'code': '',
            'password': '',
            'password2': '',
        };

        // Login User | Post Action (validate)
        $scope.loginUser = function (event) {
            if (!$scope.loginFormName.validate()) {
                event.preventDefault();
            }
        };

        // Reset Password | Show Modal
        $scope.resetPassOpen = function () {
            $scope.resetPassForm.email = '';
            var options = $scope.fancyboxOptions;
            $scope.frms_resetPassForm = formSettingsTpl;
            $.fancybox.open({
                src: "#forgot-pass",
                type: "inline",
                opts: options
            });
        }

        // Reset Password | Post Action
        $scope.resetPass = function (e, url) {
            $scope.frms_resetPassForm.message = '';
            // $scope.frms_resetPassForm.status = false;
            if (!$scope.resetPassFormName.validate()) {
                e.preventDefault();
            } else {
                $scope.frms_resetPassForm.loading = true;

                $http({
                    method: "POST",
                    url: url,
                    data: $rootScope.params($scope.resetPassForm), // pass in data as strings
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                }).then(function success(response) {
                    var responseTpl = {
                        loading: false,
                        status: true,
                        message: response.data.message
                    };
                    $scope.frms_resetPassForm = responseTpl;
                    $scope.frms_resetPassForm.loading = false;
                }, function error(response) {
                    var text = '';
                    try {
                        text = response.data.message;
                    } catch (e) {
                        text = response.statusText;
                    }

                    var responseTpl = {
                        loading: false,
                        status: false,
                        message: text
                    };
                    $scope.frms_resetPassForm = responseTpl;
                    $scope.frms_resetPassForm.loading = false;
                });
            }
        }

        // Register User | Show Modal
        $scope.registerUserOpen = function () {
            $scope.frms_registerForm.opening = true;
            // Fetch Countries list
            $http({
                method: "GET",
                url: "/helpers/countries",
            }).then(function success(response) {

                // Load countries to scope ?
                $scope.reg_countries = response.data;
                // Load Countries to select2 html element
                // $('#new-user-country-dropdown').html(response.data);

                // Add event "after close" to re inite form settings
                var options = $scope.fancyboxOptions;
                // Open registration modal
                $.fancybox.open({
                    src: "#new-user",
                    type: "inline",
                    opts: options
                });

                $('button').prop('disabled', false);

                setTimeout(function () {
                    $('.select2Search').select2({
                        width: "100%",
                        // dropdownCssClass: "z-fix"
                    });
                }, 200);

                $scope.frms_registerForm.opening = false;

            }, function error(response) {
                // TO-DO Error handling

                $scope.frms_registerForm.opening = false;
            });

        }

        $scope.getRegions = function (type) {
            var _country = 0;
            if (type == 1) {
                $scope.regform.region = null;
                _country = $scope.regform.country;
            }

            if (typeof _country === 'undefined') {
                return false;
            }
            $('#new-user-region').next('span').find('.select2-selection__placeholder').html('-- LOADING');
            $http({
                method: "GET",
                url: "/" + window.Laravel.code + "/checkout/delivery-details/get-all-areas/" + _country,
            }).then(function success(response) {
                var data = response.data;
                $scope.regform.regions = data;
                setTimeout(function () {
                    $('#new-user-region').change();
                    $('#new-user-region').next('span').find('.select2-selection__placeholder').html('-- CHOOSE REGION');
                }, 200)
            }, function error(response) {
                var data = response.data;
            });
        };

        // Register User | Post Action
        $scope.registerUser = function (regform) {
            var valid = $scope.registerForm.validate();
            if (!valid) {
                $('#new-user input.error:eq(0)').focus();
            } else {
                $scope.frms_registerForm.loading = true;
                $scope.frms_registerForm.message = '';
                regform._token = window.Laravel.csrfToken;
                $http({
                    method: "POST",
                    url: "/"+window.Laravel.code+"/account/registration/post",
                    data: $rootScope.params(regform),
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then(function success(response) {
                    $scope.frms_registerForm.loading = false;
                    $scope.frms_registerForm.message = response.data.message;
                    $scope.frms_registerForm.status = response.data.status;
                    $rootScope.getsession();
                }, function error(error) {
                    $scope.frms_registerForm.loading = false;
                    $scope.frms_registerForm.message = error.data.message;
                    $scope.frms_registerForm.status = error.data.status;
                });
            }
        };


        // Update User | Post Action
        $scope.updateUser = function () {
            $scope.updatingUser = true;
            $http({
                method: "POST",
                url: "/en/account/details/change",
                data: $rootScope.params($scope.updateUserForm), // pass in data as strings
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                } // set the headers so angular passing info as form data (not request payload)
            }).then(function (response) {
                var data = response.data;
                // $rootScope.getsession();
                if (data) {
                    $scope.enabledForm.details = 0;
                } else {
                    $scope.enabledForm.details = 1;
                }
                $scope.updatingUser = false;
            });
        };

        $scope.selectedAccountTab = 1;

        /**
         * ACCOUNT DETAILS
         */
        $scope.getUserDetails = function () {
            $rootScope.showOverlay('account');
            $http({
                method: "GET",
                url: "/account/details"
            }).then(function success(successResponse) {
                var data = successResponse.data;
                $rootScope.updateUserForm = data;
                setTimeout(function () {
                    $('#form-account-info select.select2').select2({
                        width: "100%",
                        theme: "default",
                        minimumResultsForSearch: -1,
                    });
                }, 200);
                $rootScope.getsession();
                $rootScope.hideOverlay('account');
            }, function error(errorResponse) {
                $rootScope.hideOverlay('account');
            });
        };

        /**
         * SHIPPING DETAILS
         */
        $scope.getUserShippingDetails = function () {
            $rootScope.showOverlay('account');
            $http({
                method: "GET",
                url: "/"+window.Laravel.code+"/account/addresses"
            }).then(function success(response) {
                var data = response.data
                $scope.loggeduser.shipping_details = data;
                $("#shiping-details .loadedContent").html($compile(data)($scope));
                $rootScope.hideOverlay('account');

            }, function error(response) {
                var data = response;
                console.log(data);
            });
        };

        /**
         * ORDER HISTORY
         */
        $scope.getUserOrderHistory = function () {
            $rootScope.showOverlay('account');
            $http({
                method: "GET",
                url: "/"+window.Laravel.code+"/account/orders"
            }).then(function (data) {
                $rootScope.getsession();
                $scope.loggeduser.order_history = data.data;
                $("#order-history .loadedContent").html($compile(data.data)($scope));
                $rootScope.hideOverlay('account');
            });
        };

        /**
         * WISHLIST
         */
        $scope.wishlist = {};
        $scope.getUserWishlist = function () {
            $rootScope.showOverlay('account');
            $http({
                method: "GET",
                url: "/account/wishlist"
            }).then(function success(successResponse) {
                var data = successResponse.data;
                $scope.loggeduser.wishlist = data;
                $("#account-wishlist .loadedContent").html($compile(data)($scope));
                $('[data-fancybox]').fancybox({
                    smallBtn: true,
                    animationEffect: "fade",
                    btnTpl: {
                        smallBtn: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="Close">' +
                            '<i class="icon-close icon-l"></i>' +
                            '</button>',
                    },
                    spinnerTpl: '<div class="loadingContent text-center"><p class="font-weight-bold mb-0">LOADING</p></div>',
                });
                $rootScope.hideOverlay('account');
            });
        };

        /**
         * CHANGE TAB
         */
        $scope.selectAccountTab = function (tab) {

            if ($scope.selectedAccountTab == tab && tab != 1) {
                return false;
            }

            $scope.selectedAccountTab = tab;

            if (tab == 0 || tab == 1) {
                $scope.getUserDetails();
            } else if (tab == 2) {
                $scope.getUserShippingDetails();
            } else if (tab == 3) {
                $scope.getUserOrderHistory();
            } else if (tab == 4) {
                $scope.getUserWishlist();
            } else {
                $scope.getUserDetails();
            }
        };

        //if logged in
        // $rootScope.getUser();
    }

}


// WEBPACK FOOTER //
// ./src/js/eshop/Controllers/01.account.ctrl.js